import React, {Component} from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../CSS/LoginPage.css';
//import Promise from 'promise-polyfill';
import { Switch, Route, Link } from 'react-router-dom'
import moment from 'moment'
import 'react-select/dist/react-select.css';
import Clock from '../images/Clock.svg'
import StarRatingComponent from 'react-star-rating-component';
import AppointmentService from '../utils/AppointmentService.js';
import ErrorSnackBar from '../Components/ErrorSnackBar.js';
import Trash from 'react-icons/lib/fa/trash-o';


// if (!window.Promise) {
//   window.Promise = Promise;
// }
class ApptVehicleDetails extends Component {

  constructor(props) {
    super(props);
    this.Appt = new AppointmentService()
    var rating
    var reviewComments
    var isComplete = false
    if(props.aasm_state == 'awaiting_payment' || props.aasm_state == 'awaiting_payment_age24' || props.aasm_state == 'awaiting_payment_auto_failed' || props.aasm_state == 'keys_returned'){
      isComplete = true
    }
    props.vehicle.review_rating ? rating = props.vehicle.review_rating: 0
    props.vehicle.review_comments ? reviewComments = props.vehicle.review_comments: 0
    this.state = {
      isComplete: isComplete,
      rating: rating,
      review_comments: reviewComments,
      isRated: props.vehicle.review_rating,
      open: false,
      color: '#c42d2d',
      errorMessage: false
    }

  }
  onStarClick(nextValue, prevValue, name) {
    this.setState({rating: nextValue});
  }
  handleChange = event => {
    this.setState({review_comments: event.target.value});
  }
  addRating(){
    var outerThis = this
    var vehicle = this.props.vehicle
    if(!this.state.rating || this.state.rating < 1){
      this.setState({
        open:true,
        errorMessage: "Please rate your service!"
      })
    }
    else {
        this.setState({
          open:false,
          errorMessage: ""
        })
        if(vehicle){
          this.Appt.addRating(this.state.rating, this.state.review_comments, vehicle.id, this.props.appointmentID)
          .then(res =>{
            if(res.errors){
            }
            else {
              this.setState({
                isRated: true
              })

            }
          })
          .catch(err =>{
              alert(err);
        })
      }
      else{
        //do this part
      }
    }
  }

    render(){
      var vehicle = this.props.vehicle
      var photos= vehicle.photos
      var beforePhoto = null
      var afterPhoto = null
      photos.forEach(function(photo){
        if(photo.url.includes('front') || photo.url.includes('ext')){
          if(photo.step == 'AFTER'){
            afterPhoto = photo
          }
          else if(photo.step =='BEFORE'){
            beforePhoto = photo
          }
        }
      })
      var upgradesHTML= []
      if(this.props.upgrades && this.props.upgrades.length > 0){
        this.props.upgrades.forEach(function(upgrade) {
          if(upgrade){
            upgradesHTML.push(<div className="packagePrice"><h6>{upgrade.display_title}</h6><h6 className="rightAlign">${((upgrade.amount)/100).toFixed(2)}</h6></div>)
          }
        });
      }
      return (
          <div className="appointmentVehicle">
            <div className="photosContainer">
              {beforePhoto &&
                <div>
                  <img src={beforePhoto.url} className="vehicleImage"></img>
                </div>
              }
              {afterPhoto &&
                <div>
                  <img src={afterPhoto.url} className="vehicleImage"></img>
                </div>
              }
            </div>
            <div>
              <h4>{vehicle.vehicle.year} {vehicle.vehicle.make} {vehicle.vehicle.model}</h4>
              <div className='packagePrice'>
                <h6>{vehicle.package.display_title}</h6>
                <h6 className="rightAlign">${(vehicle.package.amount_after_promo/100.0).toFixed(2)}</h6>
              </div>
              {upgradesHTML}

              {(!this.state.isRated && this.state.isComplete) &&
                <div>
                  <h5>Please rate your vehicle</h5>
                  <div className="rating-stars packagePrice">
                    <StarRatingComponent
                      name="rate1"
                      starCount={5}
                      value={this.state.rating}
                      onStarClick={this.onStarClick.bind(this)}
                    />
                    </div>
                    <h6>You may leave additional feedback if you would like.</h6>
                    <div className="packagePrice">
                      <textarea onChange={this.handleChange} className="form-control rounded-0 reviewInput" rows="3" cols="70" value={this.state.review_comments}></textarea>
                    </div>
                    <button className="submitReview" onClick={() => this.addRating()}>Submit Review</button>
                  </div>
              }
              {(this.state.isRated && this.state.isComplete) &&
                <div>
                  <h6>Rated:</h6>
                  <StarRatingComponent
                    name="rate1"
                    starCount={5}
                    value={this.state.rating}
                    onStarClick={this.onStarClick.bind(this)}
                    editing={false}
                  />
                </div>
              }
            </div>
            {(this.state.errorMessage && this.state.errorMessage.length) &&
              <ErrorSnackBar color = {this.state.color} open={this.state.open} message = {this.state.errorMessage}/>
            }
          </div>
              )
    }
}
export default ApptVehicleDetails;



// WEBPACK FOOTER //
// ./src/Components/ApptVehicleDetails.js